module.exports = __webpack_public_path__ + "static/media/1.b664e821.jpg";